import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MODEL } from "../data";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Work", href: "#work" },
  { label: "Headshots", href: "#headshots" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 1.4, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-background/80 backdrop-blur-md border-b border-border" : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-6 lg:px-12 py-5">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif text-xl tracking-tight text-foreground hover:text-accent transition-colors"
        >
          {MODEL.firstName}
          <span className="text-accent">.</span>
          {MODEL.lastName}
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground hover:text-foreground transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-xs font-bold uppercase tracking-[0.2em] text-foreground"
        >
          {open ? "Close" : "Menu"}
        </button>
      </nav>

      {open && (
        <motion.ul
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          className="md:hidden overflow-hidden border-t border-border bg-background px-6 pb-6"
        >
          {LINKS.map((l) => (
            <li key={l.href} className="py-3 border-b border-border/60">
              <a
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase()}`}
                className="text-sm font-bold uppercase tracking-[0.2em] text-foreground"
              >
                {l.label}
              </a>
            </li>
          ))}
        </motion.ul>
      )}
    </motion.header>
  );
};
